import { jsxs as _jsxs, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Text } from '@travel-frontend/core';
import { useTranslation } from 'next-i18next';
import { Container } from '../../../../../../../../components/HotelDetailsOverlay/components/AttributesSection/components/SupplierAttributes/components/Attributes/components/Container.js';
import { TooltipContent } from '../../../../../../../../components/HotelDetailsOverlay/components/AttributesSection/components/SupplierAttributes/components/Attributes/components/TooltipContent.js';
import { Flex, HelpTooltip, SegmentedList } from '../../../../../../../../primitives/index.js';
export const Attributes = ({
  data
}) => {
  const {
    t
  } = useTranslation('hotelDetailsOverlay');
  if (!data) {
    return null;
  }
  const items = data.map(({
    name,
    attributes,
    paid
  }, index) => {
    const attributesHaveContentToDisplay = attributes?.some(({
      name: name2,
      value
    }) => name2 && value);
    return _jsxs(Flex, {
      direction: "row",
      alignItems: "center",
      spacing: "8px",
      children: [_jsxs(Text, {
        preset: "labelXSmall",
        children: [name, " ", paid && t('attributesSection.paidServiceSymbol')]
      }), attributes && attributesHaveContentToDisplay && _jsx(HelpTooltip, {
        width: "fit-content",
        content: _jsx(TooltipContent, {
          data: attributes
        })
      })]
    }, index);
  });
  return _jsx(Container, {
    spacing: "16px",
    children: _jsx(SegmentedList, {
      rowSpacing: "8px",
      columnSpacing: "8px",
      items: items
    })
  });
};